import React from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';

/**
 * 89: 瀬戸内海島しょ部	航路データのポップアップ
 * 
 * 1つの地点に対して複数の航路登録があるデータ構造になっている。
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {

  const icon = menu2icon[option.id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    let ret = []

    ret.push(<>
      <div className='c-tbl-sp'>
      <dl className='dl-list is-modal-ship'><dt>桟橋ID</dt><dd>{spot["桟橋ID"]}</dd></dl>
      <dl className='dl-list is-modal-ship'><dt>寄港地（桟橋名）</dt><dd>{spot["寄港地（桟橋名）"]}</dd></dl>
      <dl className='dl-list is-modal-ship'><dt>住所</dt><dd>{spot["住所"]}</dd></dl>
      <dl className='dl-list is-modal-ship'><dt>URL</dt><dd>{ spot["桟橋URL"].includes('http') && <a href={spot["桟橋URL"]} target={"_blank"}>{spot["桟橋URL"]}</a>}</dd></dl>
      <dl className='dl-list is-modal-ship'><dt>緯度</dt><dd>{spot["緯度"]}</dd></dl>
      <dl className='dl-list is-modal-ship'><dt>経度</dt><dd>{spot["経度"]}</dd></dl>
      <table class='c-tbl c-tbl-1'>
        <tr>
        <th>航路名</th>
        <th>船種</th>
        <th>寄港地</th>
        <th>船社名等</th>
        </tr>
  
        {spot['routes'].map(route => {
  
          return <tr>
                  <td>{route["航路名"]}</td>
                  <td>{route["船種"]}</td>
                  <td>{route["寄港地"]}</td>
                  <td>{route["船社名等"]}
                    <br />{ route["URL"].includes('https') && <a href={route["URL"]} target={"_blank"}>{route["URL"]}</a>}
                    </td>
                  </tr>
        })}

      </table>
      </div>
      </>)
    
    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
